import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/bscUserAuth',
    getUserAuthList(query){
        return http({
            url: this.baseurl+'/getUserAuthList',
            method: 'post',
            params: query
        });
    },
    bindUserData(data){
        return http({
            url: this.baseurl+'/bindUserData',
            method: 'post',
            data: data
        });
    },
    getUserInfoToken(query){
        return http({
            url: '/api/swyl/v1/bscUserAuth/getUserToken',
            method: 'get',
            params: {code:query}
        });
    },
    getSingleUserInfoToken(query){
        return http({
            url: '/api/swyl/v1/bscUserAuth/getSingleSignToken',
            method: 'get',
            params: {code:query}
        });
    },
    getCluesSignToken(query){
        return http({
            url: '/api/swyl/v1/bscUserAuth/getCluesSignToken',
            method: 'get',
            params: {code:query}
        });
    },

    iamRegister(query){
        return http({
            url: '/api/website/iamRegister',
            method: 'post',
            params: query
        });
    },
}
